/* ============================================================
   LOOP MAYHEM STORE · launch build, 19.09.2026
   Product form, gallery, cart drawer, video facade. No framework,
   no money formatting: prices come pre-formatted from Liquid, the
   cart comes back as a rendered section with every cart request.
   Everything here is progressive: with JavaScript off the product
   form posts to /cart/add, the cart links hit /cart/change, and
   Shopify redirects to the Loop Mayhem cart page.
   ============================================================ */
(function () {
  'use strict';

  var DRAWER_SECTION = 'mayhem-cart-drawer';
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  /* ---------- cart drawer ---------- */

  var drawer = document.querySelector('[data-lm-drawer]');
  var lastFocus = null;

  function drawerBody() { return drawer && drawer.querySelector('[data-lm-cart-body]'); }

  /* The line images are lazy in the HTML because the drawer sits hidden on
     every page. Once the drawer is filled or opened they are wanted now, not
     after the panel has slid in (audit P16). */
  function eagerImages(scope) {
    if (!scope) return;
    scope.querySelectorAll('img[loading="lazy"]').forEach(function (img) { img.setAttribute('loading', 'eager'); });
  }

  function openDrawer(message) {
    if (!drawer) return false;
    eagerImages(drawer);
    lastFocus = document.activeElement;
    var status = drawer.querySelector('[data-lm-cart-status]');
    if (status) status.textContent = message || '';
    drawer.hidden = false;
    document.documentElement.classList.add('lm-body-lock');
    requestAnimationFrame(function () {
      drawer.classList.add('is-open');
      var panel = drawer.querySelector('.lm-drawer__panel');
      if (panel) panel.focus({ preventScroll: true });
    });
    return true;
  }

  function closeDrawer() {
    if (!drawer || drawer.hidden) return;
    drawer.classList.remove('is-open');
    document.documentElement.classList.remove('lm-body-lock');
    setTimeout(function () { drawer.hidden = true; }, 380);
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }

  function setCount(n) {
    document.querySelectorAll('[data-lm-cart-count]').forEach(function (el) {
      el.textContent = n;
      el.hidden = !n;
    });
    document.querySelectorAll('[data-lm-cart-count-text]').forEach(function (el) {
      el.textContent = ', ' + n + (n === 1 ? ' item' : ' items');
    });
  }

  /* Swap the drawer body for the freshly rendered one from a cart response. */
  function renderDrawer(sections) {
    var html = sections && sections[DRAWER_SECTION];
    var body = drawerBody();
    if (!html || !body) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.querySelector('[data-lm-cart-body]');
    if (!fresh) return;
    eagerImages(fresh);
    body.innerHTML = fresh.innerHTML;
    body.setAttribute('data-count', fresh.getAttribute('data-count'));
    setCount(parseInt(fresh.getAttribute('data-count'), 10) || 0);
  }

  function postJSON(url, payload) {
    return fetch(root + url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (r) { return r.json().then(function (j) { j._ok = r.ok; return j; }); });
  }

  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-lm-cart-open]');
    if (open && drawer) {
      if (document.querySelector('[data-lm-cart-page]')) return; // already on the cart page
      e.preventDefault();
      openDrawer('');
      return;
    }
    if (e.target.closest('[data-lm-cart-close]')) { e.preventDefault(); closeDrawer(); return; }
    if (e.target.closest('[data-lm-cart-close-link]') && drawer && !drawer.hidden) {
      closeDrawer();
      return;
    }

    var change = e.target.closest('[data-lm-change]');
    if (change) {
      e.preventDefault();
      var onPage = !!change.closest('[data-lm-cart-page]');
      var holder = change.closest('[data-lm-cart-body]');
      if (holder) holder.classList.add('is-updating');
      postJSON('cart/change.js', {
        id: change.getAttribute('data-lm-change'),
        quantity: parseInt(change.getAttribute('data-qty'), 10),
        sections: DRAWER_SECTION
      }).then(function (res) {
        if (onPage) { location.reload(); return; }
        if (!res._ok) {
          var status = drawer && drawer.querySelector('[data-lm-cart-status]');
          if (status) status.textContent = res.description || res.message || 'That did not work. Please try again.';
        }
        renderDrawer(res.sections);
      }).catch(function () {
        location.href = change.getAttribute('href');
      }).then(function () {
        if (holder) holder.classList.remove('is-updating');
      });
    }
  });

  document.addEventListener('keydown', function (e) {
    if (!drawer || drawer.hidden) return;
    if (e.key === 'Escape') { closeDrawer(); return; }
    if (e.key !== 'Tab') return;
    /* Focus trap. Without it, tabbing walks out of the open drawer into the
       page behind the backdrop. */
    var f = drawer.querySelectorAll('a[href], button:not([disabled]), input, select, [tabindex]:not([tabindex="-1"])');
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  /* ---------- product page ---------- */

  var product = document.querySelector('[data-lm-product]');
  if (product) initProduct(product);

  function initProduct(el) {
    var variants = [];
    try { variants = JSON.parse(el.querySelector('[data-lm-variants]').textContent); } catch (err) { variants = []; }
    var form = el.querySelector('[data-lm-form]');
    var select = el.querySelector('[data-lm-variant]');
    var fieldsets = el.querySelectorAll('[data-lm-option]');
    var addBtn = el.querySelector('[data-lm-add]');
    var addLabel = el.querySelector('[data-lm-add-label]');
    var errorEl = el.querySelector('[data-lm-error]');
    var track = el.querySelector('[data-lm-track]');
    var thumbs = el.querySelectorAll('[data-lm-thumb]');
    var countEl = el.querySelector('[data-lm-count]');

    /* gallery */
    function slides() { return track ? track.querySelectorAll('[data-media-id]') : []; }
    function showMedia(id) {
      var s = slides();
      for (var i = 0; i < s.length; i++) {
        if (String(s[i].getAttribute('data-media-id')) === String(id)) {
          track.scrollTo({ left: s[i].offsetLeft, behavior: 'smooth' });
          return;
        }
      }
    }
    function markActive() {
      if (!track) return;
      var i = Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
      thumbs.forEach(function (t, n) {
        var on = n === i;
        t.classList.toggle('is-active', on);
        if (on) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current');
      });
      if (countEl) countEl.textContent = String(i + 1);
    }
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { showMedia(t.getAttribute('data-lm-thumb')); });
    });
    if (track) {
      var ticking = false;
      track.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () { markActive(); ticking = false; });
      }, { passive: true });
    }

    /* variants
       An option with a single value is not rendered (colour, everywhere here),
       so the fieldsets on screen are not always options 0..n. Each one carries
       its real option index in data-lm-option; the starting point is the
       selected variant's own options, and only the positions that exist on
       screen are overwritten. Reading the fieldsets in DOM order would have
       compared the chosen size against the colour and found no variant. */
    function optionIndex(fs) {
      return parseInt(fs.getAttribute('data-lm-option'), 10) || 0;
    }
    var base = [];
    for (var b = 0; b < variants.length; b++) {
      if (String(variants[b].id) === String(select && select.value)) { base = variants[b].options.slice(); break; }
    }
    if (!base.length && variants.length) base = variants[0].options.slice();

    function selectedOptions() {
      var out = base.slice();
      fieldsets.forEach(function (fs) {
        var c = fs.querySelector('input:checked');
        if (c) out[optionIndex(fs)] = c.value;
      });
      return out;
    }
    function findVariant(opts) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i], hit = true;
        for (var j = 0; j < opts.length; j++) if (v.options[j] !== opts[j]) { hit = false; break; }
        if (hit) return v;
      }
      return null;
    }
    /* Strike out values that cannot be bought with the other options as they
       are. Only a note: the value stays clickable, the button says sold out. */
    function markAvailability(opts) {
      fieldsets.forEach(function (fs) {
        var idx = optionIndex(fs);
        fs.querySelectorAll('.lm-pill').forEach(function (pill) {
          var input = pill.querySelector('input');
          var probe = opts.slice();
          probe[idx] = input.value;
          var v = findVariant(probe);
          pill.classList.toggle('is-unavailable', !v || !v.available);
        });
      });
    }
    function applyVariant(v, opts) {
      fieldsets.forEach(function (fs) {
        var label = fs.querySelector('[data-lm-option-value]');
        if (label) label.textContent = opts[optionIndex(fs)] || '';
      });
      markAvailability(opts);
      if (!v) {
        addBtn.disabled = true;
        addLabel.textContent = 'Unavailable';
        return;
      }
      select.value = String(v.id);
      el.querySelector('[data-lm-price]').textContent = v.price;
      var was = el.querySelector('[data-lm-was]');
      if (was) { was.textContent = v.was || ''; was.hidden = !v.was; }
      var stock = el.querySelector('[data-lm-stock]');
      if (stock) {
        var show = v.stock !== null && v.stock > 0;
        stock.hidden = !show;
        if (show) el.querySelector('[data-lm-stock-n]').textContent = v.stock;
      }
      addBtn.disabled = !v.available;
      addLabel.textContent = v.available ? 'Add to cart' : 'Sold out';
      if (v.media) showMedia(v.media);
      if (window.history && history.replaceState) {
        var u = new URL(location.href);
        u.searchParams.set('variant', v.id);
        history.replaceState(history.state, '', u.toString());
      }
    }
    fieldsets.forEach(function (fs) {
      fs.addEventListener('change', function () {
        if (errorEl) errorEl.hidden = true;
        var opts = selectedOptions();
        applyVariant(findVariant(opts), opts);
      });
    });
    if (fieldsets.length) markAvailability(selectedOptions());

    /* quantity */
    var qty = el.querySelector('[data-lm-qty] input');
    el.querySelectorAll('[data-lm-step]').forEach(function (b) {
      b.addEventListener('click', function () {
        var n = (parseInt(qty.value, 10) || 1) + parseInt(b.getAttribute('data-lm-step'), 10);
        qty.value = Math.max(1, Math.min(99, n));
      });
    });

    /* add to cart */
    if (form && drawer) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (addBtn.disabled) return;
        if (errorEl) errorEl.hidden = true;
        addBtn.classList.add('is-busy');
        addBtn.setAttribute('aria-busy', 'true');
        var data = new FormData(form);
        data.append('sections', DRAWER_SECTION);
        data.append('sections_url', location.pathname);
        fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: data
        }).then(function (r) {
          return r.json().then(function (j) { return { ok: r.ok, body: j }; });
        }).then(function (res) {
          if (!res.ok) {
            if (errorEl) {
              errorEl.textContent = res.body.description || res.body.message || 'Could not add this to the cart.';
              errorEl.hidden = false;
            }
            return;
          }
          renderDrawer(res.body.sections);
          openDrawer('Added to your cart.');
        }).catch(function () {
          form.submit();
        }).then(function () {
          addBtn.classList.remove('is-busy');
          addBtn.removeAttribute('aria-busy');
        });
      });
    }

    /* "Size guide" next to the size label opens the table and scrolls to it */
    var sizesLink = el.querySelector('[data-lm-open-sizes]');
    if (sizesLink) {
      sizesLink.addEventListener('click', function (e) {
        var d = document.getElementById('lm-sizes');
        if (!d) return;
        e.preventDefault();
        d.open = true;
        d.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }
  }

  /* ---------- shop grid: sorting, in the browser ----------
     Three products on one page: reordering them is a DOM job, not a request.
     The cards carry their price in cents and their suggested position, the box
     moves the existing nodes, so no image is fetched twice. Suggested is the
     order of the blocks in the theme, and the order a customer lands on. */

  var grid = document.querySelector('[data-lm-grid]');
  var sortBox = document.querySelector('[data-lm-sort]');
  if (grid && sortBox) initSort(grid, sortBox);

  function initSort(list, box) {
    var KEY = 'lm-sort';
    var cards = [].slice.call(list.children);

    function rank(el) { return parseInt(el.getAttribute('data-lm-rank'), 10) || 0; }
    function price(el) {
      var p = el.getAttribute('data-lm-price');
      if (p === null || p === '') return null;
      var n = parseInt(p, 10);
      return isNaN(n) ? null : n;
    }
    /* A card without a price cannot be bought yet and stays at the end in
       every order. Equal prices keep the suggested order. */
    function byPrice(dir) {
      return function (a, b) {
        var pa = price(a), pb = price(b);
        if (pa === null && pb === null) return rank(a) - rank(b);
        if (pa === null) return 1;
        if (pb === null) return -1;
        if (pa === pb) return rank(a) - rank(b);
        return (pa - pb) * dir;
      };
    }
    function apply(mode) {
      var order = cards.slice();
      if (mode === 'price-asc') order.sort(byPrice(1));
      else if (mode === 'price-desc') order.sort(byPrice(-1));
      else order.sort(function (a, b) { return rank(a) - rank(b); });
      var frag = document.createDocumentFragment();
      order.forEach(function (c) { frag.appendChild(c); });
      list.appendChild(frag);
    }

    /* Keeps the choice while the customer walks into a product and back. */
    try {
      var saved = sessionStorage.getItem(KEY);
      if (saved && box.querySelector('option[value="' + saved + '"]')) box.value = saved;
    } catch (err) { /* private mode, blocked storage: the box just starts fresh */ }
    if (box.value !== 'suggested') apply(box.value);

    box.addEventListener('change', function () {
      apply(box.value);
      try { sessionStorage.setItem(KEY, box.value); } catch (err) {}
    });
  }

  /* ---------- card backs: only where there is a hover to show them ----------
     A card's second image is parked in data-lm-src / data-lm-srcset by
     Liquid. On a touch screen it would never be seen, so it is never fetched
     (audit P06). Where the primary pointer can hover, the image is restored,
     still loading="lazy", and the card gets has-alt (which switches the CSS
     hover swap on) only when the image is there. A tablet that gains a mouse
     later is caught by the change listener. */

  function restore(img) {
    var set = img.getAttribute('data-lm-srcset'), src = img.getAttribute('data-lm-src');
    if (set) img.setAttribute('srcset', set);
    if (src) img.setAttribute('src', src);
    img.removeAttribute('data-lm-srcset');
    img.removeAttribute('data-lm-src');
  }

  function loadCardBacks() {
    document.querySelectorAll('.lm-card__img--alt[data-lm-src]').forEach(function (img) {
      var card = img.closest('.lm-card');
      img.addEventListener('load', function () { if (card) card.classList.add('has-alt'); }, { once: true });
      restore(img);
    });
  }

  var hoverQuery = window.matchMedia ? window.matchMedia('(hover: hover)') : null;
  if (hoverQuery && hoverQuery.matches) {
    loadCardBacks();
  } else if (hoverQuery) {
    var onHoverChange = function (e) { if (e.matches) loadCardBacks(); };
    if (hoverQuery.addEventListener) hoverQuery.addEventListener('change', onHoverChange);
    else if (hoverQuery.addListener) hoverQuery.addListener(onHoverChange);
  }

  /* ---------- late decoration: the trailer still ----------
     Images marked data-lm-late get their source after the load event, or as
     soon as they come within 200 px of the screen, whichever is first
     (audit P08). They are decoration; the first screen gets the line. */

  var late = [].slice.call(document.querySelectorAll('img[data-lm-late]'));
  if (late.length) {
    var showLate = function (img) {
      if (!img.hasAttribute('data-lm-late')) return;
      img.removeAttribute('data-lm-late');
      restore(img);
    };
    if ('IntersectionObserver' in window) {
      var lateObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { showLate(e.target); lateObserver.unobserve(e.target); }
        });
      }, { rootMargin: '200px 0px' });
      late.forEach(function (img) { lateObserver.observe(img); });
    }
    var allLate = function () { late.forEach(showLate); };
    if (document.readyState === 'complete') allLate();
    else window.addEventListener('load', allLate, { once: true });
  }

  /* ---------- YouTube facade: nothing loads before the click ---------- */

  document.querySelectorAll('[data-lm-youtube]').forEach(function (frame) {
    frame.addEventListener('click', function () {
      var id = frame.getAttribute('data-lm-youtube');
      if (!id || frame.querySelector('iframe')) return;
      var f = document.createElement('iframe');
      f.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id) + '?autoplay=1&rel=0&modestbranding=1&playsinline=1';
      f.title = frame.getAttribute('data-lm-title') || 'Video';
      f.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
      f.allowFullscreen = true;
      frame.innerHTML = '';
      frame.appendChild(f);
    });
  });
})();
